import { SOURCE_ID, addSource, getAddBefore } from "./geoFeaturesSource";

/* EIA shale play outlines — analog of the Enverus "ENV Plays" layer. */
const LAYER_ID = "plays";

const SOURCE_LAYER_PLAYS = "geo_features_plays";
const SOURCE_LAYER_LABELS = "geo_features_labels";

const LAYER_PLAYS_ID = "Plays";
const LAYER_LABELS_ID = "Plays labels";

const TOGGLE_LAYER_IDS = [LAYER_PLAYS_ID, LAYER_LABELS_ID];

const addLayers = (mapRef) => {
  const map = mapRef.current;
  const addBefore = getAddBefore(map);

  if (!map.getLayer(LAYER_PLAYS_ID)) {
    map.addLayer(
      {
        id: LAYER_PLAYS_ID,
        type: "fill",
        source: SOURCE_ID,
        "source-layer": SOURCE_LAYER_PLAYS,
        layout: {
          visibility: "none",
        },
        paint: {
          "fill-color": "#721ea9",
          "fill-opacity": 0.08,
          "fill-outline-color": "#721ea9",
        },
      },
      addBefore
    );
  }

  if (!map.getLayer(LAYER_LABELS_ID)) {
    map.addLayer(
      {
        id: LAYER_LABELS_ID,
        type: "symbol",
        source: SOURCE_ID,
        "source-layer": SOURCE_LAYER_LABELS,
        filter: ["==", ["get", "type"], "play"],
        layout: {
          visibility: "none",
          "text-field": ["to-string", ["get", "name"]],
          "text-font": ["Prompt Regular", "Arial Unicode MS Regular"],
          "text-size": 10,
        },
        paint: {
          "text-color": "#721ea9",
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
        },
      },
      addBefore
    );
  }
};

const addAll = (mapRef) => {
  addSource(mapRef);
  addLayers(mapRef);
};

const setAnnotationVisibility = (action) => {
  const { mapRef, value } = action;

  if (!mapRef || !mapRef.current) return;

  const map = mapRef.current;
  const visibility = value ? "visible" : "none";

  TOGGLE_LAYER_IDS.forEach((layerId) => {
    if (map.getLayer(layerId)) {
      map.setLayoutProperty(layerId, "visibility", visibility);
    }
  });
};

export {
  SOURCE_ID,
  LAYER_ID,
  LAYER_PLAYS_ID,
  LAYER_LABELS_ID,
  addAll,
  setAnnotationVisibility,
};
